<div class="sp-mb-16 feedback-input">
  <textarea [(ngModel)]="userFeedback" [uiFocus]="true" ui-input maxlength="500" data-test-id="suggestion-feedback-text-area"></textarea>
</div>
